import type { IconData } from '@stacksjs/iconify-core'

export const messenger: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M3.683 16.418C1.436 14.722 0 12.14 0 9.248C0 4.14 4.477 0 10 0s10 4.14 10 9.248s-4.477 9.248-10 9.248a10.8 10.8 0 0 1-2.96-.412l-3.357 1.891zm5.25-9.703l-5.394 5.66l4.908-2.67l2.565 2.67l5.362-5.66l-4.853 2.622l-2.589-2.622z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default messenger
